import React from 'react';
import styled from 'styled-components';
import { TabPanel, NumberedList, NumberedListItem } from './InstallSDK.styles';
import { useNavigate } from 'react-router-dom';
import useAnalytics from '../../../../hooks/useAnalytics';

const Title = styled.p`
  margin: 24px;
  text-wrap: pretty;
`;

export default function NodeTab() {
  const analytics = useAnalytics();
  const navigate = useNavigate();

  const handleApiKeysClick = () => {
    analytics.capture('api_keys_clicked');
    navigate('/api-keys');
  };

  const onClickDocs = () => {
    analytics.capture('sdk_doc_clicked', { runtime: 'nodejs' });
  };

  return (
    <TabPanel value="nodejs">
      <Title>Follow the steps to initialize Hud in your service:</Title>
      <NumberedList>
        <NumberedListItem>
          <div className="content">
            Install the SDK using the{' '}
            <a
              href="https://docs.hud.io/docs/nodejs-installation-guide"
              onClick={onClickDocs}
              target="_blank"
              rel="noopener noreferrer"
            >
              installation guide
            </a>
            .
          </div>
        </NumberedListItem>
        <NumberedListItem>
          <div className="content">
            Create an initialization file with your{' '}
            <button onClick={handleApiKeysClick}>API Keys</button>.
          </div>
        </NumberedListItem>
        <NumberedListItem>
          <div className="content vertical">
            <p>
              Preload the file with <code>--require</code>
            </p>
            <small>(or use one of the other installation alternatives)</small>
          </div>
        </NumberedListItem>
      </NumberedList>
    </TabPanel>
  );
}
